module.exports = __webpack_public_path__ + "img/nuvola_0.32168683.png";